import { render, staticRenderFns } from "./MailboxesView.vue?vue&type=template&id=d4021552&lang=pug&"
import script from "./MailboxesView.vue?vue&type=script&lang=js&"
export * from "./MailboxesView.vue?vue&type=script&lang=js&"
import style0 from "./MailboxesView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports